import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconChart = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 17,
	height: 16,
	fill: "none",
	viewBox: "0 0 17 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#333333",
		d: "M12.717 2h-9.37c-.737 0-1.34.6-1.34 1.333v9.334c0 .733.603 1.333 1.34 1.333h9.37c.736 0 1.339-.6 1.339-1.333V3.333C14.056 2.6 13.453 2 12.717 2zm-6.693 9.333H4.685V6.667h1.339v4.666zm2.677 0H7.362V4.667h1.339v6.666zm2.677 0H10.04V8.667h1.338v2.666z"
	})
});
export default SvgIconChart;
